"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
export type InferAnimationStateKeys<T> = T extends `has${infer U}AnimationPlayed` ? Lowercase<U> : T extends `has${infer U}Played` ? Lowercase<U> : T;
export interface AnimationState {
  hasTypewriterPlayed: boolean;
  hasHeroAnimationPlayed?: boolean;
  hasScrollAnimationPlayed?: boolean;
  hasLoadingAnimationPlayed: boolean;
}
export const useAnimationState = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      hasTypewriterPlayed: false,
      hasHeroAnimationPlayed: false,
      hasScrollAnimationPlayed: false,
      hasLoadingAnimationPlayed: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [animationStates, setAnimationStates] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      typewriter: false,
      hero: false,
      scroll: false,
      loading: false
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const animationRefs = useRef(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = animationType => {
      setAnimationStates(prev => ({
        ...prev,
        [animationType]: true
      }));
      if (animationType === "hasTypewriterPlayed") {
        animationRefs.current.typewriter = true;
      }
      if (animationType === "hasLoadingAnimationPlayed") {
        animationRefs.current.loading = true;
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setAnimationComplete = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAnimationStates({
        hasTypewriterPlayed: false,
        hasHeroAnimationPlayed: false,
        hasScrollAnimationPlayed: false,
        hasLoadingAnimationPlayed: false
      });
      animationRefs.current = {
        typewriter: false,
        hero: false,
        scroll: false,
        loading: false
      };
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const resetAnimations = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setAnimationStates(_temp);
      animationRefs.current.typewriter = false;
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const resetTypewriterAnimation = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setAnimationStates(_temp2);
      animationRefs.current.loading = false;
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const resetLoadingAnimation = t5;
  let t6;
  if ($[6] !== animationStates) {
    t6 = {
      animationStates,
      setAnimationComplete,
      resetAnimations,
      resetTypewriterAnimation,
      resetLoadingAnimation,
      animationRefs
    };
    $[6] = animationStates;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
function _temp(prev_0) {
  return {
    ...prev_0,
    hasTypewriterPlayed: false
  };
}
function _temp2(prev_1) {
  return {
    ...prev_1,
    hasLoadingAnimationPlayed: false
  };
}